module.exports = __webpack_public_path__ + "img/020.c265df37.jpg";